<!--设备本地日志-->
<template>
  <div class="device-log">
    <div class="header">
      <span class="back" @click="goBack"><i class="iconfont icon-fanhui" style="font-size: 24px;"></i></span>
      <!-- <div class="title">设备日志 {{ deviceName }}</div> -->
      <div class="title">设备日志</div>
    </div>
    <el-form :inline="true" :model="form">
      <el-form-item label="设备ID">
        <el-input v-model="form.deviceId" placeholder="请输入设备ID" style="width: 220px" clearable @keyup.enter.native="queryList('search')" />
      </el-form-item>
      <el-form-item label="消息类型" prop="logType">
        <el-select v-model="form.logType" placeholder="全部" clearable>
          <el-option
            v-for="item in messageTypeOptions"
            :key="item.key"
            :label="item.label"
            :value="item.key"
            :disabled="item.disabled"
          />
        </el-select>
      </el-form-item>
      <el-form-item prop="method">
        <template v-slot:label>
          <span class="form-label-help">
            方法
            <el-tooltip content="MQTT 为 method" placement="top">
              <i class="iconfont icon-wenhao" style="font-size: 16px;"></i>
            </el-tooltip>
          </span>
        </template>
        <el-input
          v-model="form.method"
          placeholder="请输入方法"
          clearable
        />
      </el-form-item>
      <el-form-item prop="action">
        <template #label>
          <span class="form-label-help">
            动作
            <el-tooltip content="MQTT 为主题" placement="top">
              <i class="iconfont icon-wenhao" style="font-size: 16px;"></i>
            </el-tooltip>
          </span>
        </template>
        <el-input
          v-model="form.action"
          placeholder="请输入动作"
          clearable
        />
      </el-form-item>
      <el-form-item label="协议id" prop="runid">
        <el-input v-model="form.runid" placeholder="请输入协议id" style="width: 220px" clearable />
      </el-form-item>
      <el-form-item class="date">
        <template v-slot:label>
          <span class="form-label-help">
            时间(GMT+8)
            <el-tooltip content="所选时间跨度不能超过30天" placement="top">
              <i class="iconfont icon-wenhao" style="font-size: 16px;"></i>
            </el-tooltip>
          </span>
        </template>
        <!-- 时间限制：不能选未来时间，开始和结束最大跨度30天 -->
        <el-date-picker
          v-model="form.dateTime"
          type="datetimerange"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          format="yyyy/MM/dd HH:mm"
          value-format="yyyy-MM-dd HH:mm"
          clearable
          :picker-options="pickerOptions"
          @change="handleDateTimeChange"
        />

      </el-form-item>

      <el-form-item>
        <el-button type="primary" class="button-container" size="14" @click="queryList">搜索</el-button>
        <el-button v-if="activeName === '设备本地日志'" type="primary" class="button-container" size="14" @click="startCollect">启动收集</el-button>
        <el-button v-if="activeName === '设备本地日志'" type="primary" class="button-container" size="14" @click="stopCollect">停止收集</el-button>
      </el-form-item>
    </el-form>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane v-for="tab in tabs" :key="tab.id" :label="tab.label" :name="tab.name">
        <transition name="fade">
          <el-table
            v-loading="loading"
            :data="tableData"
            style="width: 100%"
            size="medium"
            :header-cell-style="{ background: '#F5F6F7' }"
          >
            <el-table-column
              type="index"
              label="序号"
              width="80"
            />
            <el-table-column
              prop="clientId"
              label="来源"
            >
              <template slot-scope="scope">
                {{ scope.row.clientId || '-' }}
              </template>
            </el-table-column>
            <el-table-column
              prop="ts"
              label="时间(GMT+8)"
            />
            <el-table-column
              prop="did"
              label="设备ID"
            />
            <el-table-column
              prop="logType"
              label="消息类型"
            />
            <el-table-column
              prop="method"
              label="方法"
            />
            <el-table-column
              prop="runid"
              label="协议id"
            />
            <el-table-column
              prop="content"
              label="内容"
              width="200"
            >
              <template slot-scope="{ row }">
                <el-tooltip
                  v-if="row.content"
                  effect="light"
                  placement="top"
                  popper-class="json-tooltip"
                >
                  <template #content>
                    <pre>{{ formatJsonContent(row.content) }}</pre>
                  </template>
                  <span class="content-text">
                    {{ row.content }}
                  </span>
                </el-tooltip>
                <div v-else>-</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="ipAddr"
              label="设备IP地址"
            >
              <template slot-scope="{ row }">
                {{ row.ipAddr || '-' }}
              </template>
            </el-table-column>
            <el-table-column
              prop="action"
              label="动作"
            />
          </el-table>
        </transition>
      </el-tab-pane>
    </el-tabs>
    <el-pagination
      :current-page="currentPage"
      :page-sizes="[10, 20, 50]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange">
    </el-pagination>
  </div>
</template>
<script>
import { deviceLogPageList, startCollect, stopCollect } from '@/api/device/log'
import moment from 'moment'
// import ClipboardJS from 'clipboard'
export default {
  name: 'deviceLog',
  data() {
    const self = this
    return {
      pickerMinDate: '', // 暂存首次选择的时间节点
      form: {
        deviceId: null, // 设备ID
        logType: null, // 消息类型
        method: null, // 方法
        action: null, // 动作
        runid: '', // 协议id
        startDateTime: '', // 开始时间
        endDateTime: '', // 结束时间
        dateTime: [moment().subtract(30, "minutes").format("YYYY-MM-DD HH:mm"), moment().format("YYYY-MM-DD HH:mm")] // 时间数组
      },
      // deviceId: '', // 设备ID
      // deviceName: '', // 设备名称
      // logTypeData: [], // 类型数据
      // logType: '', // 类型
      dateValue: [// 存储选择的日期范围
        moment().subtract(6, 'days').format('YYYY-MM-DD'),
        moment().subtract(0, 'days').format('YYYY-MM-DD')
      ],
      messageTypeOptions: [// 消息类型选项(日志类型)选项
        { key: 'mqtt', label: 'mqtt', disabled: false },
        { key: 'device-gateway-log', label: 'device-gateway-log', disabled: false }
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: '最近30分钟',
            onClick(picker) {
              const end = moment().toDate()
              const start = moment().subtract(30, 'minutes').toDate()
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近1小时',
            onClick(picker) {
              const end = moment().toDate()
              const start = moment().subtract(1, 'hours').toDate()
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近1天',
            onClick(picker) {
              const end = moment().toDate()
              const start = moment().subtract(1, 'days').toDate()
              picker.$emit('pick', [start, end])
            }
          }
        ],
        onPick({ maxDate, minDate }) {
          self.pickerMinDate = minDate ? minDate.getTime() : ''
          if (maxDate) {
            self.pickerMinDate = ''
          }
        },
        disabledDate(time) {
          // 不能选择未来时间
          if (time.getTime() > Date.now()) {
            return true
          }
          // 选中第一个点后，前后不能超过30天（30 * 24 * 3600 * 1000 ms）
          if (self.pickerMinDate) {
            const thirtyDays = 30 * 24 * 3600 * 1000
            const minTime = self.pickerMinDate - thirtyDays
            const maxTime = self.pickerMinDate + thirtyDays
            return time.getTime() < minTime || time.getTime() > maxTime
          }
          return false
        }
      },
      tableData: [], // 列表数据
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页条数
      total: 0, // 列表数据总条数
      loading: false,
      activeName: '全部设备日志',
      tabs: [
        { id: 1, label: '全部设备日志', name: '全部设备日志' },
        { id: 2, label: '设备本地日志', name: '设备本地日志' }
      ]
    }
  },
  watch: {
    'form.deviceId'(newValue) {
      sessionStorage.setItem('deviceId', newValue)
    }
  },
  created() {
    if (!(sessionStorage.getItem('deviceId') !== null || undefined)) {
      this.form.deviceId = this.$route.query.deviceId || ''
    } else {
      this.form.deviceId = sessionStorage.getItem('deviceId')
    }
    this.deviceName = this.$route.query.deviceName
    this.queryList()
  },
  destroyed() {
    sessionStorage.removeItem('deviceId') // 调用处理离开的方法
  },
  methods: {
    /**
     * 设备日志详情
     * current 当前页码
     * size 每页条数
     */
    queryList() {
      if (!this.form.deviceId) {
        this.$message.warning("请输入设备ID")
        return
      }
      this.loading = true
      const params = {
        current: this.currentPage,
        size: this.pageSize,
        did: this.form.deviceId,
        logType: this.form.logType,
        method: this.form.method,
        action: this.form.action,
        runid: this.form.runid,
        startDateTime: this.form.dateTime && this.form.dateTime[0] ? moment(this.form.dateTime[0]).format("YYYY-MM-DD HH:mm") : '',
        endDateTime: this.form.dateTime && this.form.dateTime[1] ? moment(this.form.dateTime[1]).format("YYYY-MM-DD HH:mm") : ''
      }
      deviceLogPageList(params).then(res => {
        this.tableData = res.data.data.records
        this.total = res.data.data.total
      }).catch(err => {
        this.$message.error(err.message)
      }).finally(() => {
        this.loading = false
      })
    },
    // 启动收集
    startCollect() {
      const params = {
        deviceId: this.form.deviceId
      }
      startCollect(params).then(res => {
        this.$message.success('启动收集成功')
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 停止收集
    stopCollect() {
      const params = {
        deviceId: this.form.deviceId
      }
      stopCollect(params).then(res => {
        this.$message.success('停止收集成功')
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 切换表格tab
    handleClick(tab) {
      this.activeName = tab.name
      this.currentPage = 1
      if (tab.index === '1') {
        this.form.logType = 'device-gateway-log'
        this.messageTypeOptions = this.messageTypeOptions.map(item => ({ ...item, disabled: item.key === 'mqtt' }))
      } else {
        this.form.logType = null
        this.messageTypeOptions = this.messageTypeOptions.map(item => ({ ...item, disabled: false }))
      }
      this.queryList()
    },
    // 返回设备列表
    goBack() {
      this.$router.push({ path: '/product/device-log/index' })
    },
    // 每页条数改变时触发
    handleSizeChange(val) {
      this.pageSize = val
      this.queryList()
    },
    // 当前页变时触发
    handleCurrentChange(val) {
      this.currentPage = val
      this.queryList()
    },
    // 时间改变时触发
    handleDateTimeChange(val) {
      this.pickerMinDate = ''
    },
    // 格式化日志内容
    formatJsonContent(content) {
      if (!content) return ''

      try {
        const value = typeof content === 'string' ? JSON.parse(content) : content
        return JSON.stringify(value, null, 2)
      } catch (e) {
        return String(content)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.device-log {
  height: 100%;

  .header {
    display: flex;
    align-items: center;
    margin-bottom: 17px;

    .title {
      cursor: pointer;
    }

    .title {
      font-size: 18px;
      font-weight: 600;
      color: #252525;
    }
  }

  .form-label-help {
    display: inline-flex;
    align-items: center;
    gap: 4px;
  }

  .search-form {
    margin-bottom: 8px;

    .date {
      margin-left: 24px;

      ::v-deep .el-form-item__content {
        display: flex;
      }

      .date-picker {
        margin-right: 10px;
      }
    }

    .log-type {
      width: 150px;
    }

    .search-btn {
      float: right;

      .button-container {
        margin-left: 25px;
      }
    }

    .search-icon {
      cursor: pointer;
    }
  }
}

.content-text {
  display: block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cell-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.icon-copy {
  display: flex;
  flex-direction: row-reverse;
  cursor: pointer;
}

::v-deep .el-range-separator {
  color: #606266;
  padding: 0;
}

::v-deep .el-table .el-loading-spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
